import { render, staticRenderFns } from "./ib-wait-spin.vue?vue&type=template&id=1a02a6a8&scoped=true&lang=pug&"
import script from "./ib-wait-spin.vue?vue&type=script&lang=js&"
export * from "./ib-wait-spin.vue?vue&type=script&lang=js&"
import style0 from "./ib-wait-spin.vue?vue&type=style&index=0&id=1a02a6a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a02a6a8",
  null
  
)

/* custom blocks */
import block0 from "./ib-wait-spin.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a02a6a8')) {
      api.createRecord('1a02a6a8', component.options)
    } else {
      api.reload('1a02a6a8', component.options)
    }
    module.hot.accept("./ib-wait-spin.vue?vue&type=template&id=1a02a6a8&scoped=true&lang=pug&", function () {
      api.rerender('1a02a6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/progress/ib-wait-spin.vue"
export default component.exports